"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _underscore = require("underscore");
var _sources = require("@studio/sources");
var _program = require("@studio/program");
var _constants = require("@studio/constants");
var _queueStageLayout = _interopRequireDefault(require("../program/queueStageLayout"));
var _types = require("./types");
var _notification = require("../notification");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function toggleStageSource(source) {
  return function (dispatch, getState) {
    var _getState = getState(),
      broadcastSources = _getState.broadcastSources.sources,
      _getState$stagedSourc = _getState.stagedSources,
      currentlyStagedSources = _getState$stagedSourc.sources,
      stagedSceneLayout = _getState$stagedSourc.sceneLayout;
    var stagedSources = _objectSpread({}, currentlyStagedSources || {});
    var sourceId = source._id,
      sourceType = source.type;

    // Are we trying to add the source to the list of staged sources?
    var isStaged = stagedSources[sourceId];

    // If we're staging the source, and we'll exceed the limit we show the
    // notification and return. If we're not staging we're un-staging the
    // source. We should not attempt to enforce the limit in this case.
    if (!isStaged && Object.keys(stagedSources).length >= _constants.CAMERA_PRESENTER_LIMIT) {
      return dispatch((0, _notification.showNotification)("You're at the max of ".concat(_constants.CAMERA_PRESENTER_LIMIT, " sources available at a time on stage."), {
        timeout: 3500,
        type: 'alert'
      }));
    }
    var isAudioSource = sourceType === _constants.AUDIO_FILE;
    var stagedSourceIds = Object.keys(stagedSources).filter(function (sourceId) {
      return stagedSources[sourceId];
    });
    var _getVisualMediaSource = (0, _sources.getVisualMediaSourcesInProgram)(stagedSourceIds, broadcastSources),
      _getVisualMediaSource2 = _slicedToArray(_getVisualMediaSource, 1),
      stagedVisualMediaSource = _getVisualMediaSource2[0];
    var isVisualMediaSourceStaged = !(0, _underscore.isEmpty)(stagedVisualMediaSource);

    // replace staged visual media source w/ the new visual media source
    if (isVisualMediaSourceStaged && (0, _sources.isVisualMediaSource)(source) && !isStaged) {
      // un stage previous visual media source
      delete stagedSources[stagedVisualMediaSource._id];
      stagedSources[sourceId] = true;
    } else {
      stagedSources[sourceId] = !isStaged;
    }
    if (stagedSources[sourceId] === false) {
      delete stagedSources[sourceId];
    }

    /**
     * Since AUDIO_FILE should NOT change scene layout,
     * when selected, we just return previously selected layout
     * so UI does not change.
     */
    var sceneLayout = isAudioSource ? stagedSceneLayout : (0, _program.queueSceneLayoutSelector)(stagedSources, broadcastSources);
    var action = {
      type: _types.BROADCAST_TOGGLE_STAGE_SOURCE,
      payload: stagedSources
    };
    (0, _reactRedux.batch)(function () {
      dispatch(action);
      dispatch((0, _queueStageLayout["default"])(sceneLayout));
    });
  };
}
var _default = exports["default"] = toggleStageSource;